import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { MemberDetails, PcpsData } from '../interfaces/search-result-object.interface';
import { CareTypeTerms, FilterTerms, ProviderTypes, SearchOptionTypes, SortTypes } from '../models/FIlterTerms';
import { BrowseTypes, PageTypes, QueryTerms } from '../models/QueryTerms';
import { UserRulesService } from './user-rules.service';

@Injectable({
    providedIn: 'root'
})

export class SearchObjectService {
    searchObject: SearchObject;
    tabsData: TabsData;
    searchViaFilters: Subject<boolean> = new Subject<boolean>();
    filterHardCode: FilterHardCode;
    private pcpsData: PcpsData = {} as PcpsData;
    private memberData: MemberDetails;

    constructor(private router: Router, private userRulesService: UserRulesService) {
        this.searchObject = new SearchObject();
        this.tabsData = new TabsData();
        this.filterHardCode = new FilterHardCode();
    }

    isMedicationSearch() {
        return this.searchObject && this.searchObject.careType && this.searchObject.careType.toLowerCase() === PageTypes.medication;
    }

    setMedicationSearchURL(loginSearch?) {
        const queryParams = {};

        if (this.searchObject.careType) {
            queryParams[QueryTerms.caretype] = this.searchObject.careType;
        }

        if (this.searchObject.networkId) {
            queryParams[QueryTerms.networkid] = this.searchObject.networkId;
        }

        if (this.searchObject.drugId) {
            queryParams[QueryTerms.drugId] = this.searchObject.drugId;
        }
        if (this.searchObject.drugName) {
            queryParams[QueryTerms.drugName] = this.searchObject.drugName;
        }
        if (this.searchObject.benefitYear) {
            queryParams[QueryTerms.benefitYear] = this.searchObject.benefitYear;
        }
        if (this.searchObject.formularyId) {
            queryParams[QueryTerms.formularyId] = this.searchObject.formularyId;
        }

        if (loginSearch) {
            queryParams[QueryTerms.type] = this.searchObject.loginType;
            if (this.searchObject.shopNetwork) {
                queryParams[QueryTerms.network] = this.searchObject.shopNetwork;
            }
        }

        this.router.navigate(['/medication'], { queryParams: queryParams });
    }

    setSearchURL(useFilters, loginSearch?, subkey?) {
        const queryParams = {};
        const isMedicationSearch = this.isMedicationSearch();
        if (isMedicationSearch) {
            this.setMedicationSearchURL(loginSearch);
        } else {
            if (this.userRulesService.isUserPCP()) {
                if (this.searchObject.providerName) {
                    queryParams[QueryTerms.providername] = this.searchObject.providerName;
                }

                if (this.searchObject.address) {
                    queryParams[QueryTerms.address] = this.searchObject.address;
                }
                if (this.searchObject.mileRadius) {
                    queryParams[QueryTerms.mileradius] = this.searchObject.mileRadius;
                }
                if (this.searchObject.oldMileRadius) {
                    queryParams[QueryTerms.oldmileradius] = this.searchObject.oldMileRadius;
                }
                
                if (this.searchObject.isMultiSpecialtySearch) {
                    queryParams[QueryTerms.ismultispecialtysearch] = this.searchObject.isMultiSpecialtySearch;
                }

                queryParams[QueryTerms.type] = BrowseTypes.find;
            } else {

                if (this.searchObject.searchOption) {
                    queryParams[QueryTerms.searchoption] = this.searchObject.searchOption;
                }
                if (this.searchObject.careType) {
                    queryParams[QueryTerms.caretype] = this.searchObject.careType;
                }

                if (this.searchObject.searchOption === SearchOptionTypes.providerName) {
                    if (this.searchObject.providerName) {
                        queryParams[QueryTerms.providername] = this.searchObject.providerName;
                    }
                }

                if (this.searchObject.searchOption === SearchOptionTypes.phoneNumber) {
                    if (this.searchObject.phoneNumber) {
                        queryParams[QueryTerms.phoneNumber] = this.searchObject.phoneNumber.replace(/\D/g, '');
                    }
                }

                if (this.searchObject.searchOption === SearchOptionTypes.specialty) {
                    if (this.searchObject.specialty !== null) {
                        queryParams[QueryTerms.specialty] = this.searchObject.specialty;
                    }
                    if (this.searchObject.providerType) {
                        queryParams[QueryTerms.providertype] = this.searchObject.providerType;
                    }
                    if (this.searchObject.service != null) {
                        queryParams[QueryTerms.service] = this.searchObject.service;
                    }
                    if (this.searchObject.specialtyType != null) {
                        queryParams[QueryTerms.specialtytype] = this.searchObject.specialtyType;
                    }
                }

                if (this.searchObject.address) {
                    queryParams[QueryTerms.address] = this.searchObject.address;
                }
                if (this.searchObject.mileRadius) {
                    queryParams[QueryTerms.mileradius] = this.searchObject.mileRadius;
                }
                if (this.searchObject.oldMileRadius) {
                    queryParams[QueryTerms.oldmileradius] = this.searchObject.oldMileRadius;
                }
                if (this.searchObject.networkId) {
                    queryParams[QueryTerms.networkid] = this.searchObject.networkId;
                }

                if (this.searchObject.isServiceAreaSearch) {
                    queryParams[QueryTerms.isserviceareasearch] = this.searchObject.isServiceAreaSearch;
                }

                if (this.searchObject.isMultiSpecialtySearch) {
                    queryParams[QueryTerms.ismultispecialtysearch] = this.searchObject.isMultiSpecialtySearch;
                }

                if (this.searchObject.searchYear) {
                    queryParams[QueryTerms.searchYear] = this.searchObject.searchYear;
                }

                if (this.searchObject.benefitYear) {
                    queryParams[QueryTerms.benefitYear] = this.searchObject.benefitYear;
                }
            }

            if (useFilters) {

                this.searchViaFilters.next(true);

                if (!this.searchObject.filters.people) {
                    queryParams[QueryTerms.people] = this.searchObject.filters.people.toString();
                }

                if (!this.searchObject.filters.places) {
                    queryParams[QueryTerms.places] = this.searchObject.filters.places.toString();
                }

                if (this.searchObject.filters.acceptingNewPatients) {
                    queryParams[QueryTerms.acceptingnewpatients] = this.searchObject.filters.acceptingNewPatients.toString();
                }

                if (this.searchObject.filters.eveningHours) {
                    queryParams[QueryTerms.eveninghours] = this.searchObject.filters.eveningHours.toString();
                }

                if (this.searchObject.filters.weekendHours) {
                    queryParams[QueryTerms.weekendhours] = this.searchObject.filters.weekendHours.toString();
                }

                if (this.searchObject.filters.handicapAccess) {
                    queryParams[QueryTerms.handicapaccess] = this.searchObject.filters.handicapAccess.toString();
                }

                if (this.searchObject.filters.telehealth) {
                    queryParams[QueryTerms.telehealth] = this.searchObject.filters.telehealth.toString();
                }

                if (this.searchObject.filters.accreditedFacility) {
                    queryParams[QueryTerms.accreditedfacility] = this.searchObject.filters.accreditedFacility.toString();
                }

                if (this.searchObject.filters.subProductKey && !this.userRulesService.isUserPCP()) {
                    queryParams[QueryTerms.subproductkey] = this.searchObject.filters.subProductKey;
                }

                if (this.searchObject.filters.planDisplayKey) {
                    queryParams[QueryTerms.plandisplaykey] = this.searchObject.filters.planDisplayKey;
                }

                if (this.searchObject.filters.language) {
                    queryParams[QueryTerms.language] = this.searchObject.filters.language;
                }

                if (this.searchObject.filters.gender) {
                    queryParams[QueryTerms.gender] = this.searchObject.filters.gender;
                }

                if (this.searchObject.filters.hospitalPrivilege) {
                    queryParams[QueryTerms.hospitalprivilege] = this.searchObject.filters.hospitalPrivilege;
                }

                if (this.searchObject.filters.page) {
                    queryParams[QueryTerms.page] = this.searchObject.filters.page;
                }
                if (this.searchObject.filters.level) {
                    queryParams[QueryTerms.level] = this.searchObject.filters.level;
                }
                if (this.searchObject.filters.pos) {
                    queryParams[QueryTerms.pos] = this.searchObject.filters.pos;
                }

                if (this.searchObject.filters.sortType) {
                    queryParams[QueryTerms.sortType] = this.searchObject.filters.sortType;
                }

                // if (this.searchObject.filters.lgbtqia) {
                //     queryParams[QueryTerms.lgbtqia] = this.searchObject.filters.lgbtqia;
                // }

            }

            if (subkey) {
                if (this.searchObject.filters.subProductKey && !this.userRulesService.isUserPCP()) {
                    queryParams[QueryTerms.subproductkey] = this.searchObject.filters.subProductKey;
                }

                if (this.searchObject.filters.planDisplayKey) {
                    queryParams[QueryTerms.plandisplaykey] = this.searchObject.filters.planDisplayKey;
                }
            }

            if (loginSearch) {
                queryParams[QueryTerms.type] = this.searchObject.loginType;
                if (this.searchObject.shopNetwork) {
                    queryParams[QueryTerms.network] = this.searchObject.shopNetwork;
                }
                if (this.searchObject.memberObject.loggedIn) {
                    if (this.searchObject.filters.subProductKey) {
                        queryParams[QueryTerms.subproductkey] = this.searchObject.filters.subProductKey;
                    } else {
                        queryParams[QueryTerms.subproductkey] = this.searchObject.memberObject.careTypes[0].multiYearPlans.length > 0 && this.searchObject.memberObject.careTypes[0].multiYearPlans[0].subProductKey ? this.searchObject.memberObject.careTypes[0].multiYearPlans[0].subProductKey : '';
                    }
                }
            }

            this.router.navigate(['/search'], { queryParams: queryParams });
        }
    }

    setSearchObjectQuery(obj: any) {
        if (obj.params) {
            const params = obj.params;

            if (this.userRulesService.isUserPCP()) {
                this.searchObject.loginType = params[QueryTerms.type];

                const memberObj = this.searchObject.memberObject.careTypes.filter(o => o.careType === CareTypeTerms.Medical);

                if (memberObj && memberObj[0]) {
                    this.searchObject.networkId = memberObj[0].networkId;
                    this.searchObject.filters.subProductKey = memberObj[0].subProductKey;
                    // this.searchObject.filters.subProductKey = memberObj[0].subProductKey;
                    this.searchObject.careType = memberObj[0].careType;
                }

                this.searchObject.address = params[QueryTerms.address] ? params[QueryTerms.address] : null;

                this.searchObject.mileRadius = params[QueryTerms.mileradius] ? params[QueryTerms.mileradius] : '20';
                
                this.searchObject.oldMileRadius = params[QueryTerms.oldmileradius] ? params[QueryTerms.oldmileradius] : null;
                this.searchObject.isMultiSpecialtySearch = params[QueryTerms.ismultispecialtysearch] ? (params[QueryTerms.ismultispecialtysearch] === 'true' ? true : false) : false;

                this.searchObject.providerName = params[QueryTerms.providername] ? params[QueryTerms.providername].replace(/[^a-zA-Z0-9 \'\,\.\-]/g, '') : null;
                this.searchObject.phoneNumber = params[QueryTerms.phoneNumber] ? (params[QueryTerms.phoneNumber].replace(/\D/g, '').substring(0, 10)).replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2 - $3') : null;

                this.searchObject.providerType = ProviderTypes.pcp;

                //virtual pcp only flag
                if (this.memberData && this.memberData.eligibilities.length > 0) {
                    var validMemberArr = this.memberData.eligibilities.find(o => o.eligibilityStatus === 'Active');
                    if (validMemberArr) {
                        if (validMemberArr.isDigitalFirstMember) {
                            this.searchObject.digitalMember = true;
                        }
                    }
                }
            } else {

                if (params[QueryTerms.type] === BrowseTypes.find || params[QueryTerms.type] === BrowseTypes.shop || params[QueryTerms.type] === BrowseTypes.employer) {
                    this.searchObject.loginType = params[QueryTerms.type];
                    this.searchObject.shopNetwork = params[QueryTerms.network];
                    if (!this.searchObject.memberObject.loggedIn) {
                        this.searchObject.memberObject.careTypes.push({
                            altDestinationUrl: params[QueryTerms.altDestinationUrl] ? params[QueryTerms.altDestinationUrl] : undefined,
                            careType: params[QueryTerms.caretype] ? params[QueryTerms.caretype] : [],
                            networkId: params[QueryTerms.networkid] ? params[QueryTerms.networkid] : undefined,
                            multiYearPlans: [],
                            subProductKey: params[QueryTerms.subproductkey] ? params[QueryTerms.subproductkey] : undefined,
                            isServiceAreaSearch: params[QueryTerms.isserviceareasearch] ? (params[QueryTerms.isserviceareasearch] === 'true' ? true : false) : false,
                            isMultiSpecialtySearch: params[QueryTerms.ismultispecialtysearch] ? (params[QueryTerms.ismultispecialtysearch] === 'true' ? true : false) : false,
                            notificationText: '',
                            shouldDisplayPlanYearPicker: undefined
                        });
                    }
                }

                this.searchObject.careType = params[QueryTerms.caretype] ? params[QueryTerms.caretype] : undefined;
                this.searchObject.networkId = params[QueryTerms.networkid] ? params[QueryTerms.networkid] : undefined;
                this.searchObject.address = params[QueryTerms.address] ? params[QueryTerms.address] : null;

                this.searchObject.mileRadius = params[QueryTerms.mileradius] ? params[QueryTerms.mileradius] : '20';
                this.searchObject.oldMileRadius = params[QueryTerms.oldmileradius] ? params[QueryTerms.oldmileradius] : null;
                this.searchObject.searchOption = params[QueryTerms.searchoption] ? params[QueryTerms.searchoption] : null;
                this.searchObject.providerName = params[QueryTerms.providername] ? params[QueryTerms.providername].replace(/[^a-zA-Z0-9 \'\,\.\-]/g, '') : null;
                this.searchObject.phoneNumber = params[QueryTerms.phoneNumber] ? (params[QueryTerms.phoneNumber].replace(/\D/g, '').substring(0, 10)).replace(/^(\d{0,3})(\d{0,3})(\d{0,4})/, '($1) $2 - $3') : null;
                this.searchObject.specialty = params[QueryTerms.specialty] ? params[QueryTerms.specialty] : null;
                this.searchObject.providerType = params[QueryTerms.providertype] ? params[QueryTerms.providertype] : null;
                this.searchObject.service = params[QueryTerms.service] ? JSON.parse(params[QueryTerms.service]) : false;
                this.searchObject.specialtyType = params[QueryTerms.specialtytype] ? params[QueryTerms.specialtytype] : null;
                this.searchObject.userInput = params[QueryTerms.providertype] ? params[QueryTerms.providertype] : (params[QueryTerms.specialty] ? params[QueryTerms.specialty] : null);
                this.searchObject.isServiceAreaSearch = params[QueryTerms.isserviceareasearch] ? (params[QueryTerms.isserviceareasearch] === 'true' ? true : false) : false;
                this.searchObject.isMultiSpecialtySearch = params[QueryTerms.ismultispecialtysearch] ? (params[QueryTerms.ismultispecialtysearch] === 'true' ? true : false) : false;
                this.searchObject.searchYear = params[QueryTerms.searchYear] ? params[QueryTerms.searchYear] : undefined;

            }

            //Medications Search 
            this.searchObject.drugId = params[QueryTerms.drugId] ? params[QueryTerms.drugId] : undefined;
            this.searchObject.drugName = params[QueryTerms.drugName] ? params[QueryTerms.drugName] : undefined;
            this.searchObject.benefitYear = params[QueryTerms.benefitYear] ? params[QueryTerms.benefitYear] : undefined;
            this.searchObject.formularyId = params[QueryTerms.formularyId] ? params[QueryTerms.formularyId] : undefined;

            this.searchObject.filters.people = params[QueryTerms.people] ? (params[QueryTerms.people] === 'false' ? false : true) : true;
            this.searchObject.filters.places = params[QueryTerms.places] ? (params[QueryTerms.places] === 'false' ? false : true) : true;
            this.searchObject.filters.acceptingNewPatients = params[QueryTerms.acceptingnewpatients] ? (params[QueryTerms.acceptingnewpatients] === 'true' ? true : false) : false;
            this.searchObject.filters.eveningHours = params[QueryTerms.eveninghours] ? (params[QueryTerms.eveninghours] === 'true' ? true : false) : false;
            this.searchObject.filters.weekendHours = params[QueryTerms.weekendhours] ? (params[QueryTerms.weekendhours] === 'true' ? true : false) : false;
            this.searchObject.filters.handicapAccess = params[QueryTerms.handicapaccess] ? (params[QueryTerms.handicapaccess] === 'true' ? true : false) : false;
            this.searchObject.filters.telehealth = params[QueryTerms.telehealth] ? (params[QueryTerms.telehealth] === 'true' ? true : false) : false;
            this.searchObject.filters.accreditedFacility = params[QueryTerms.accreditedfacility] ? (params[QueryTerms.accreditedfacility] === 'true' ? true : false) : false;
            if (!this.userRulesService.isUserPCP()) {
                this.searchObject.filters.subProductKey = params[QueryTerms.subproductkey] ? params[QueryTerms.subproductkey] : undefined;
                this.searchObject.filters.planDisplayKey = params[QueryTerms.plandisplaykey] ? params[QueryTerms.plandisplaykey] : undefined;
            }
            this.searchObject.filters.language = params[QueryTerms.language] ? params[QueryTerms.language] : undefined;
            this.searchObject.filters.gender = params[QueryTerms.gender] ? params[QueryTerms.gender] : undefined;
            this.searchObject.filters.hospitalPrivilege = params[QueryTerms.hospitalprivilege] ? params[QueryTerms.hospitalprivilege] : undefined;

            this.searchObject.filters.page = params[QueryTerms.page] ? params[QueryTerms.page] : undefined;
            this.searchObject.filters.level = params[QueryTerms.level] ? params[QueryTerms.level] : undefined;
            this.searchObject.filters.pos = params[QueryTerms.pos] ? params[QueryTerms.pos] : undefined;
            this.searchObject.filters.sortType = params[QueryTerms.providername] ? (params[QueryTerms.sortType] ? params[QueryTerms.sortType] : SortTypes.BestMatch) : SortTypes.Distance;
            // this.searchObject.filters.lgbtqia = params[QueryTerms.lgbtqia] ? (params[QueryTerms.lgbtqia] === 'true' ? true : false) : false;
        }
    }

    setSearchObject(searchObject: SearchObject) {
        this.searchObject = JSON.parse(JSON.stringify(searchObject));
    }

    getSearchObject() {
        return JSON.parse(JSON.stringify(this.searchObject));
    }

    isFormularyIdCheck() {
        const formularyId = this.searchObject.formularyId && this.searchObject.formularyId.split('displayKey_').length > 1 ? this.searchObject.formularyId.split('displayKey_')[1] : this.searchObject.formularyId;
        return ['5'].includes(formularyId);
    }

    getZipCode() {
        return this.searchObject.zipCode;
    }

    getCounty() {
        return this.searchObject.county;
    }

    getState() {
        return this.searchObject.state;
    }

    getAddress() {
        return this.searchObject.address;
    }

    getSearchYear() {
        return this.searchObject.searchYear;
    }

    getSubProductKey() {
        const subkeyFilter = this.filterHardCode.searchObjArr.filter(obj => obj.networkId === this.searchObject.networkId);
        if (subkeyFilter.length > 0 && subkeyFilter[0].subProductKey) {
            this.searchObject.filters.subProductKey = subkeyFilter[0].subProductKey;  // set subkey has hardcoded key
            return subkeyFilter[0].subProductKey;
        } else {
            return this.searchObject.filters.subProductKey || '';
        }
    }

    getPlanDisplayKey() {
        const subkeyFilter = this.filterHardCode.searchObjArr.filter(obj => obj.networkId === this.searchObject.networkId);
        if (subkeyFilter.length > 0 && subkeyFilter[0].planDisplayKey) {
            return subkeyFilter[0].planDisplayKey;
        } else {
            return this.searchObject.filters.planDisplayKey || '';
        }
    }

    setLatLong(lat: number, long: number) {
        this.searchObject.lat = lat;
        this.searchObject.long = long;
    }

    setZipcode(zipcode) {
        this.searchObject.zipCode = zipcode;
    }

    setCounty(county) {
        this.searchObject.county = county;
    }

    setState(state) {
        this.searchObject.state = state;
    }

    getLat() {
        return this.searchObject.lat;
    }

    getLong() {
        return this.searchObject.long;
    }

    getCareType() {
        return this.searchObject.careType;
    }

    getNetworkID() {
        return this.searchObject.networkId;
    }

    getDigitalMember() {
        return this.searchObject.digitalMember;
    }

    isValidSearchObject() {
        return this.searchObject.networkId && this.searchObject.address &&
            (this.searchObject.providerName || this.searchObject.phoneNumber || this.searchObject.specialty || this.searchObject.providerType);
    }

    isValidMedicationSearchObject() {
        return this.searchObject.networkId && this.searchObject.formularyId && this.searchObject.drugId && this.searchObject.benefitYear;
    }

    isValidAddress() {
        return this.searchObject.address;
    }

    isAddressZipcode() {
        return /(^\d{5}$)/.test(this.searchObject.address);
    }

    containsLatLong(address) {
        return this.searchObject.address === address && this.searchObject.lat && this.searchObject.long;
    }

    showLevels() {
        return this.searchObject.filters.subProductKey || this.searchObject.memberObject.loggedIn;
    }

    getSearchCriteria() {
        let searchArr = [];
        let userInput = '';
        if (this.searchObject.userInput) {
            searchArr = this.searchObject.userInput.split('|');

            if (searchArr.length === 1) {
                userInput = searchArr[0];
            } else if (searchArr.length > 1) {
                userInput = `${searchArr[0]}`;
                for (let i = 1; i < searchArr.length - 1; i++) {
                    userInput += `, ${searchArr[i]},`;
                }
                userInput += ` and ${searchArr[searchArr.length - 1]}`;
            }
        }

        return {
            userInput: userInput ? userInput : this.searchObject.searchOption === SearchOptionTypes.phoneNumber ? this.searchObject.phoneNumber : this.searchObject.providerName,
            radius: this.searchObject.mileRadius,
            address: this.searchObject.address
        };
    }

    getUserInput() {
        return this.searchObject.userInput;
    }

    checkPeoplePlacesFilter(): boolean {
        if (!this.searchObject.filters.people && !this.searchObject.filters.places) {
            return false;
        } else {
            return true;
        }
    }

    getSearchType() {
        const searchTypeFilter = this.filterHardCode.searchObjArr.filter(obj => obj.networkId === this.searchObject.networkId);
        if (searchTypeFilter.length > 0 && searchTypeFilter[0].searchTypeFilter) {
            return searchTypeFilter[0].searchTypeFilter;
        } else {
            if (this.userRulesService.isUserPCP()) {
                return 'Pcp';
            } else {
                if (this.searchObject.isMultiSpecialtySearch || this.searchObject.specialtyType === FilterTerms.SpecialtyAndService) {
                    if (!this.searchObject.filters.people) {
                        return FilterTerms.Facility;
                    } else if (!this.searchObject.filters.places) {
                        return FilterTerms.Practitioner;
                    } else {
                        return 'null';
                    }
                } else if (this.searchObject.providerName) {
                    if (!this.searchObject.filters.people) {
                        return FilterTerms.Facility;
                    } else if (!this.searchObject.filters.places) {
                        return FilterTerms.Practitioner;
                    } else {
                        return 'null';
                    }
                } else if ((this.searchObject.providerType || this.searchObject.specialty) && !this.searchObject.service) {
                    return FilterTerms.Practitioner;
                } else if (!this.searchObject.providerType && this.searchObject.service) {
                    return FilterTerms.Facility;
                }
            }
        }
    }

    getSearchTypeFilter() {
        const searchTypeFilter = this.filterHardCode.searchObjArr.filter(obj => obj.networkId === this.searchObject.networkId);
        if (searchTypeFilter.length > 0 && searchTypeFilter[0].searchTypeFilter) {
            return searchTypeFilter[0].searchTypeFilter;
        } else {
            if (this.userRulesService.isUserPCP()) {
                return FilterTerms.Practitioner;
            } else {
                if (this.searchObject.searchOption === SearchOptionTypes.phoneNumber || this.searchObject.specialtyType === FilterTerms.SpecialtyAndService || this.searchObject.isMultiSpecialtySearch) {
                    return FilterTerms.Both;
                } else if (this.searchObject.providerName) {
                    return FilterTerms.Both;
                } else if ((this.searchObject.providerType || this.searchObject.specialty) && !this.searchObject.service) {
                    return FilterTerms.Practitioner;
                } else if (!this.searchObject.providerType && this.searchObject.service) {
                    return FilterTerms.Facility;
                }
            }
        }
    }

    getProviderName() {
        return this.searchObject.providerName;
    }

    getPhoneNumber() {
        return this.searchObject.phoneNumber;
    }

    setFilters(filters) {
        for (const filter of filters) {
            switch (filter.name) {
                case FilterTerms.subProductKey: {
                    this.searchObject.filters.subProductKey = filter.value;
                    this.searchObject.filters.planDisplayKey = filter.displayKey;
                    break;
                }
                default : {
                    this.searchObject.filters[filter.name] = filter.value;
                    break;
                }
            }
        }
    }

    setFilterPage(page) {
        this.searchObject.filters.page = page;
    }

    getFilterPage() {
        return this.searchObject.filters.page;
    }

    setFilterLevel(level) {
        this.searchObject.filters.level = level;
    }

    getFilterLevel() {
        return this.searchObject.filters.level;
    }

    setFilterPos(pos) {
        this.searchObject.filters.pos = pos;
    }

    getFilterPos() {
        return this.searchObject.filters.pos;
    }

    setCareTypes(careTypes) {
        this.searchObject.memberObject.careTypes = careTypes;
    }

    setLoggedIn(loggedIn, loginType?) {
        this.tabsData.loginData = new SearchObject();
        //this.searchObject = new SearchObject();
        if (loginType) {
            this.searchObject.loginType = loginType;
        } else {
            this.searchObject.loginType = BrowseTypes.find;
        }
        this.searchObject.memberObject.loggedIn = loggedIn;
    }

    isLoggedIn() {
        return this.searchObject.memberObject.loggedIn;
    }

    getLoginData() {
        this.tabsData.browseData = JSON.parse(JSON.stringify(this.searchObject));
        this.searchObject = JSON.parse(JSON.stringify(this.tabsData.loginData));
    }
    getLoginType() {
        return this.searchObject.loginType;
    }
    getBrowseData() {
        this.tabsData.loginData = JSON.parse(JSON.stringify(this.searchObject));
        this.searchObject = JSON.parse(JSON.stringify(this.tabsData.browseData));
    }

    checkNetworkSubKey(networkid, subproductkey): boolean {
        let res = false;
        if (this.searchObject.memberObject.loggedIn) {
            for (const caretype of this.searchObject.memberObject.careTypes) {
                if (caretype.networkId === networkid && caretype.subProductKey === subproductkey) {
                    res = true;
                }
            }
        }
        return res;
    }

    clearPlaceObject() {
        this.searchObject.placeObject = null;
    }

    setPlaceObject(obj) {
        this.searchObject.placeObject = obj;
    }

    updateQueryParams(key, value) {
        const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
        const separator = window.location.href.indexOf('?') !== -1 ? '&' : '?';
        if (window.location.href.match(re)) {
            window.history.pushState(null, null, window.location.href.replace(re, '$1' + key + '=' + value + '$2'));
        } else {
            window.history.pushState(null, null, window.location.href + separator + key + '=' + value);
        }
    }

    removeQueryParams(key) {
        const re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
        const separator = window.location.href.indexOf('?') !== -1 ? '&' : '?';
        if (window.location.href.match(re)) {
            window.history.pushState(null, null, window.location.href.replace(re, '$1' + '$2'));
        } else {
            window.history.pushState(null, null, window.location.href + separator);
        }
    }

    setPcpData(data: PcpsData) {
        this.pcpsData = data;
    }

    getPcpData(): PcpsData {
        return this.pcpsData;
    }

    getMemberData(): MemberDetails {
        return this.memberData;
    }
    setMemberData(data: MemberDetails) {
        this.memberData = data;
    }

    isCigna() {
        return this.getNetworkID() === '0000010000010001100011';
    }
}

export class SearchObject {
    constructor() {
        this.memberObject = new MemberObject();
        this.filters = {
            people: true,
            places: true,
            acceptingNewPatients: false,
            eveningHours: false,
            weekendHours: false,
            handicapAccess: false,
            telehealth: false,
            accreditedFacility: false,
            subProductKey: undefined,
            planDisplayKey: undefined,
            language: undefined,
            gender: undefined,
            hospitalPrivilege: undefined,
            page: undefined,
            level: undefined,
            pos: undefined,
            sortType: SortTypes.BestMatch,
            lgbtqia: false
        };
    }
    placeObject: any;
    memberObject: MemberObject;
    loginType: string;
    searchOption: string;
    careType: CareTypeTerms;
    coverageType: string;
    searchYear: string;
    productKey: string;
    networkId: string;
    specialty: string;
    providerName: string;
    phoneNumber: string;
    service: boolean;
    specialtyType: string;
    providerType: string;
    userInput: string;
    zipCode: string;
    address: string;
    county: string;
    state: string;
    isServiceAreaSearch: boolean; // for county area searches, require state and county variables
    isMultiSpecialtySearch: boolean; // for multispecialty search checkboxes
    mileRadius = '20';
    oldMileRadius: string;
    lat: number;
    long: number;
    altDestinationUrl: string;
    shopNetwork: string;
    digitalMember: boolean; // for special digital cards display
    drugId: string;
    drugName: string;
    formularyId: string;
    benefitYear: number;
    filters: {
        people: boolean;
        places: boolean;
        acceptingNewPatients: boolean;
        eveningHours: boolean;
        weekendHours: boolean;
        handicapAccess: boolean;
        telehealth: boolean;
        accreditedFacility: boolean;
        subProductKey: string;
        planDisplayKey: string;
        language: string;
        gender: string;
        hospitalPrivilege: string;
        page: number;
        level: string;
        pos: number;
        sortType: string;
        lgbtqia: boolean;
    };
}

class MemberObject {
    constructor() {
        this.loggedIn = false;
        this.careTypes = [];
    }
    loggedIn: boolean;
    careTypes: Array<MemberCareTypes>;
}

class MemberCareTypes {
    constructor() {
        this.multiYearPlans = [];
    }

    altDestinationUrl: string;
    networkId: string;
    careType: CareTypeTerms;
    multiYearPlans?: Array<{
        subProductKey: string;
        planYear?: string;
        altDestinationUrl?: string;
    }>;
    isServiceAreaSearch: boolean;
    isMultiSpecialtySearch: boolean;
    shouldDisplayPlanYearPicker?: boolean;
    renewalDate?: string;
    notificationText?: string;
    selectedSubKey?: string;
    subProductKey?: string;
    formularyId?: string;
    formularyDescription?: string;

}


class TabsData {
    constructor() {
        this.loginData = new SearchObject();
        this.browseData = new SearchObject();
    }
    loginData: SearchObject;
    browseData: SearchObject;
}

class FilterHardCode {
    constructor() { }

    searchObjArr: FilterExceptionObj[] = [{
        networkId: '0000010000010001500001',
        searchTypeFilter: FilterTerms.Facility
    }, {
        networkId: '0000010000010001600004',
        subProductKey: '204',
        planDisplayKey: '40'
    }];
}

class FilterExceptionObj {
    networkId: string;
    searchTypeFilter?: string;
    subProductKey?: string;
    planDisplayKey?: string;
}
